import { ENV_PARTS, ENV_UNIONEDEV } from './constants';

const defaultEnvPart = ENV_UNIONEDEV;

export const envAutoDetector = (authHost?: string) => {
  const host = authHost || window.location.origin;
  const match = ENV_PARTS.find((envPart) => host.includes(envPart));

  return match || defaultEnvPart;
};
